import { render } from "./CartBlock.vue?vue&type=template&id=8fd2aa9a&scoped=true"
import script from "./CartBlock.vue?vue&type=script&lang=js"
export * from "./CartBlock.vue?vue&type=script&lang=js"

import "./CartBlock.vue?vue&type=style&index=0&id=8fd2aa9a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd2aa9a"]])

export default __exports__